import {Outlet, Navigate} from 'react-router-dom';

const ProtectedRoute = () => {
    const user = null;
    return user ? <Outlet /> : <Navigate to="/wwwwww" />;
}

export default ProtectedRoute;